import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 300,
    outline: 'none',
    borderRadius: '16px',
    backgroundColor: '#fff',
    border: '1px solid #e2e8f0',
    color: '#1e293b',
    padding: theme.spacing(3, 3, 1),
  },
}));

const SimpleModal = (props) => {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render

  return (
    <Modal
      open={props.open}
      onClose={props.close}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={classes.paper} style={props?.style}>
        {props.children}
      </div>
    </Modal>
  );
}

export default SimpleModal;

